// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageDropdown_container__1KgEE","select":"LanguageDropdown_select__jMgeT","loader":"LanguageDropdown_loader__2WUKF"};